//DASHBOARD
import DashGeneral from 'akasia-components/dashboards/general';
import CatalogoTicketSoporte from 'akasia-components/dashboards/soporte-tecnico/CatalogoTicketSoporte';
import AkasiaPosDashboard from 'akasia-components/dashboards/akasia-pos/AkasiaPosDashboard';
import AdministradoresReporteVentas from 'akasia-components/dashboards/ventas/AdministradoresReporteVentas';

//ADMINISTRACION
import Pagos from 'akasia-components/administracion/pagos/Pagos';
import CuentasStripePayPal from 'akasia-components/administracion/cuentas/Cuentas';
import ActivoFijo from 'akasia-components/administracion/activo-fijo/ActivoFijo';
import RegistroActivoFijo from 'akasia-components/administracion/activo-fijo/RegistroActivoFijo';
import UsuariosAP from 'akasia-components/administracion/usuarios-sistema/UsuariosAP';
import DetalleUsuarioAP from 'akasia-components/administracion/usuarios-sistema/DetalleEmpleado';
import RegistroUsuarioAP from 'akasia-components/administracion/usuarios-sistema/RegistroEmpleado';
import VacacionesPendientes from 'akasia-components/administracion/usuarios-sistema/VacacionesPendientes';
import Gastos from 'akasia-components/administracion/gastos/Gastos';


//LEADS
import Leads from 'akasia-components/leads/Contacts';
import DashboardLeads from 'akasia-components/leads/dashboard/AdministradoresReporteLeads';

//MARKETING
import CalendarioEditorial from 'akasia-components/marketing/calendario-editorial/CalendarioEditorial';
import MarketingDashboard from 'akasia-components/marketing/dashboard/MarketingDashboard';

//CONTABILIDAD
import AjustesFacturacion from 'akasia-components/Contabilidad/Ajustes/AjustesContabilidad';
import ModalDatosFiscales from 'akasia-components/Contabilidad/Ajustes/ModalDatosFiscales';
import CargarXML from 'akasia-components/Contabilidad/centro-xml/descarga-masiva/CargarXML';
import FormularioFactura from 'akasia-components/Contabilidad/facturas/formulario-factura/FormularioFactura';
import Nominas from 'akasia-components/Contabilidad/nomina/timbrado-nomina/Nomina';
import Emitidas from 'akasia-components/Contabilidad/centro-xml/facturas-emitidas/Emitidas';
import Recibidas from 'akasia-components/Contabilidad/centro-xml/facturas-recibidas/Recibidas';
import VisualizacionFacturasEmitidas from 'akasia-components/Contabilidad/centro-xml/facturas-emitidas/VisualizacionFacturasEmitidas';
import VisualizacionFacturasRecibidas from 'akasia-components/Contabilidad/centro-xml/facturas-recibidas/VisualizacionFacturasRecibidas';
import PagosEmitidos from 'akasia-components/Contabilidad/centro-xml/pagos-emitidos/PagosEmitidos';
import VisualizacionFacturasPE from 'akasia-components/Contabilidad/centro-xml/pagos-emitidos/VisualizacionFacturasPagosEmitidos';
import PagosRecibidos from 'akasia-components/Contabilidad/centro-xml/pagosrecibidos/pagosrecibidos';
import VisualizacionFacturasPR from 'akasia-components/Contabilidad/centro-xml/pagosrecibidos/VisualizacionFacturasPagosRecibidos';
import Impuestos from 'akasia-components/Contabilidad/impuestos/Impuestos';


//CLIENTES
import Clientes from 'akasia-components/cliente/Clientes';
import ClientesInfoIncompleta from 'akasia-components/cliente/ClientesInfoIncompleta';
import ConctactosDuplicados from 'akasia-components/cliente/ConctactosDuplicados';
import DetallesCliente from 'akasia-components/cliente/DetallesCliente';
import NuevoCliente from 'akasia-components/cliente/NuevoCliente';
import NuevaOrden from 'akasia-components/cliente/orden/NuevaOrden';
import Orders from 'akasia-components/cliente/orden/CatalogoOrdenes';
import OrderDetails from 'akasia-components/cliente/orden/DetalleOrden';
import DetallesSoporte from 'akasia-components/dashboards/soporte-tecnico/detalles-soporte/ContactDetails';
import RecargasTaecel from 'akasia-components/cliente/recargas-taecel/RecargasTaecel';
import Distribuidores from 'akasia-components/cliente/distribuidor/Distribuidores';


//PRODUCTOS
import Productos from 'akasia-components/productos/Productos';
import AgregarProductos from 'akasia-components/productos/AgregarProducto';
import DetalleProducto from 'akasia-components/productos/DetalleProducto';


//MÓDULOS
import CatModulos from 'akasia-components/productos/modulos-akasiapos/CatModulos';


//LICENCIAS
import DetallesLicencia from 'akasia-components/licencia/DetallesLicencia';
import EditarUsuarioNubeAkasia from 'akasia-components/licencia/EditarUsuarioNubeAkasia';
import Licencias from 'akasia-components/licencia/Licencias';
import LicenciasInfoIncompleta from 'akasia-components/licencia/LicenciasInfoIncompleta';
import NuevaLicencia from 'akasia-components/licencia/NuevaLicencia';
import NuevaAppComandas from 'akasia-components/licencia/NuevaLicenciaAppComandas';
import NuevaLicenciaCaja from 'akasia-components/licencia/NuevaLicenciaCaja';
import NuevaLicenciaNube from 'akasia-components/licencia/NuevaLicenciaNube';
import NuevaLicenciaServidor from 'akasia-components/licencia/NuevaLicenciaServidor';
import NuevaLicenciaAkasiaPOS from 'akasia-components/licencia/NuevaLicenciaAkasiaPOS';
import NuevoUsuarioNubeAkasia from 'akasia-components/licencia/NuevoUsuarioNubeAkasia';
import UsuariosNubeAkasia from 'akasia-components/licencia/UsuariosNubeAkasia';
import LogServicios from 'akasia-components/licencia/logs/LogServicios';
import DetallesPoliza from 'akasia-components/licencia/poliza/DetallesPoliza';


//POS-FACTURACION
import FacturaDocumentosEcuador from 'akasia-components/modulos-facturacion/factura-ecuador/FacturaDocumentosEcuador';
import FacturaDocumentosGuatemala from 'akasia-components/modulos-facturacion/factura-guatemala/FacturaDocumentosGuatemala';
import PlanesFacturacionBolivia from 'akasia-components/modulos-facturacion/factura-bolivia/PlanesFacturacionBolivia';
import PlanesFacturacionPanama from 'akasia-components/modulos-facturacion/factura-panama/PlanesFacturacionPanama';
import PlanesFacturacionPeru from 'akasia-components/modulos-facturacion/factura-peru/PlanesFacturacionPeru';
import PlanesFacturacionCostaRica from 'akasia-components/modulos-facturacion/factura-costarica/PlanesFacturacionCostaRica';
import PlanesFacturacionElSalvador from 'akasia-components/modulos-facturacion/factura-elsalvador/PlanesFacturacionElSalvador';
import PlanesFacturacionRepublicaDominicana from 'akasia-components/modulos-facturacion/factura-republica-dominicana/PlanesFacturacionRepublicaDominicana';


//AUTHENTICATION
import ConfirmarEmail from 'akasia-components/authentication/simple/ConfirmarEmail';
import SimpleForgetPassword from 'akasia-components/authentication/simple/ForgetPassword';
import SimpleLogin from 'akasia-components/authentication/simple/Login';
import SimpleLogout from 'akasia-components/authentication/simple/Logout';
import SimplePasswordReset from 'akasia-components/authentication/simple/PasswordReset';


import ConciliarFacturas from 'akasia-components/Contabilidad/bancos/conciliacion/conciliar/ConciliarFacturas';


//PROFILE
import Profile from 'akasia-components/profile/Profile';


//AUXILIARES DEL SISTEMA ADMIN PANEL

import Logo from 'components/common/Logo';
import Section from 'components/common/Section';
import useToken from 'hooks/useToken';
import AuthSimpleLayout from 'layouts/AuthSimpleLayout';




import Notifications from 'akasia-components/notification/NotificationsPage';
import MainLayout from 'layouts/MainLayout';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Route, Routes } from 'react-router-dom';




















const FalconRoutes = () => {


    const { token } = useToken();

    if (!token) {
        return (
            <Section className="py-0">
                <Row className="flex-center min-vh-100 py-6">
                    <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
                        <Logo />
                        <Card>
                            <Card.Body className="p-4 p-sm-5">
                                <SimpleLogin />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Section>
        );
    }




    return (
        <Routes>

            {/*- ------------- Authentication ---------------------------  */}

            {/*- ------------- simple ---------------------------  */}
            <Route element={<AuthSimpleLayout />}>
                <Route path="authentication/simple/login" element={<SimpleLogin />} />

                <Route path="authentication/simple/logout" element={<SimpleLogout />} />
                <Route
                    path="authentication/simple/forgot-password"
                    element={<SimpleForgetPassword />}
                />
                <Route
                    path="authentication/simple/reset-password"
                    element={<SimplePasswordReset />}
                />
                <Route
                    path="authentication/simple/confirm-mail"
                    element={<ConfirmarEmail />}
                />
            </Route>


            {/* //--- MainLayout Starts  */}
            <Route element={<MainLayout />}>

                {/*Dashboard*/}
                <Route path="/" element={<DashGeneral />} />

                <Route path="/dashboard/support-desk" element={<CatalogoTicketSoporte />} />
                <Route path="/dashboard/akasia-pos" element={<AkasiaPosDashboard />} />
                <Route path="/dashboard/reporte-ventas" element={<AdministradoresReporteVentas />} />
                <Route path="/dashboard/reporte-seguimiento-leads" element={<DashboardLeads />} />

                {/*Leads*/}
                <Route path="/leads/catalogo" element={<Leads />} />

                {/*Notificaciones*/}
                <Route path="/notificaciones" element={<Notifications />} />

                {/*administracion */}

                <Route path="/administracion/pagos" element={<Pagos />} />
                <Route path="/administracion/cuentas-stripe-paypal" element={<CuentasStripePayPal />} />
                <Route path="/administracion/activo-fijo" element={<ActivoFijo />} />
                <Route path="/administracion/activo-fijo/nuevo" element={<RegistroActivoFijo />} />
                <Route path="/administracion/activo-fijo/editar/:id" element={<RegistroActivoFijo />} />
                <Route path="/administracion/usuarios-sistema/lista" element={<UsuariosAP />} />
                <Route path="/administracion/usuarios-sistema/nuevo" element={<RegistroUsuarioAP />} />
                <Route path="/administracion/usuarios-sistema/detalle/:id" element={<DetalleUsuarioAP />} />
                <Route path="/administracion/usuarios-sistema/vacaciones" element={<VacacionesPendientes />} />
                <Route path="/administracion/gastos" element={<Gastos />} />



                <Route path="/contabilidad/facturacion/Pagos-emitidos" element={<PagosEmitidos />} />
                <Route path="/contabilidad/facturacion/Ajustes" element={<AjustesFacturacion />} />
                <Route path="/contabilidad/facturacion/Modal/:idDatoFiscal" element={<ModalDatosFiscales />} />
                <Route path="/contabilidad/conciliacion/conciliacion-bancos" element={<ConciliarFacturas />} />

                {/*<Route path="/contabilidad/facturacion/cargar-xml" element={<CargarXML />} />*/}
                {/* <Route path="/contabilidad/gastos" element={<Gastos />} />*/}
                {/*//<Route path="/contabilidad/Facturacion/cargar-xml" element={<CargarXML />} />*/}
                {/*//<Route path="/contabilidad/FacturasEmitidas" element={<Emitidas />} />*/}
                {/*//<Route path="/contabilidad/FacturasRecibidas" element={<Recibidas />} />*/}
                {/*<Route path="/contabilidad/facturacion/Ajustes" element={<AjustesFacturacion />} />*/}
                {/*<Route path="/contabilidad/configuracion/cuentas" element={<Cuentas />} />*/}



                <Route path="/contabilidad/empleados/nuevo" element={<RegistroUsuarioAP />} />
                <Route path="/contabilidad/empleados/detalle/:id" element={<DetalleUsuarioAP />} />
                <Route path="/contabilidad/Gastos" element={<Gastos />} />
                <Route path="/contabilidad/Impuestos" element={<Impuestos />} />


                {/*Contabilidad/facturacion */}
                <Route path="/contabilidad/facturacion/formulario-factura/:id?" element={<FormularioFactura />} />
                <Route path="/contabilidad/centro-xml/pagos-emitidos" element={<PagosEmitidos />} />
                <Route path="/contabilidad/centro-xml/pagos-emitidos/FacturaPagoEmitido/:id" element={<VisualizacionFacturasPE />} />
                <Route path="/contabilidad/centro-xml/pagos-recibidos" element={<PagosRecibidos />} />
                <Route path="/contabilidad/centro-xml/pagos-recibidos/FacturaPagoRecibido/:id" element={<VisualizacionFacturasPR />} />
                <Route path="/contabilidad/facturacion/ajustes" element={<AjustesFacturacion />} />
                <Route path="/contabilidad/centro-xml/descarga-masiva/cargar-xml" element={<CargarXML />} />
                <Route path="/contabilidad/centro-xml/facturas-emitidas" element={<Emitidas />} />
                <Route path="/contabilidad/centro-xml/facturas-emitidas/visualizacion/:id" element={<VisualizacionFacturasEmitidas />} />
                <Route path="/contabilidad/centro-xml/facturas-recibidas" element={<Recibidas />} />
                <Route path="/contabilidad/centro-xml/facturas-recibidas/visualizacion/:id" element={<VisualizacionFacturasRecibidas />} />
                <Route path="/contabilidad/facturacion/nomina" element={<Nominas />} />






                {/*Clientes */}
                <Route path="/clientes" element={<Clientes />} />

                <Route path="/clientes/detalle/:id" element={<DetallesCliente />} />
                <Route path="/clientes/nuevo" element={<NuevoCliente />} />
                <Route path="/clientes/informacionincompleta/:vFiltro" element={<ClientesInfoIncompleta />} />
                <Route path="/clientes/contactosduplicados/:vFiltro" element={<ConctactosDuplicados />} />

                {/*Distribuidores*/}
                <Route path="/distribuidores" element={<Distribuidores />} />

                {/* Ordenes */}
                <Route path="/ordenes/detalle/:id" element={<OrderDetails />} />
                <Route path="/ordenes/" element={<Orders />} />
                <Route path="/ordenes/nueva/:idClienteAkasia?/:idOrden?" element={<NuevaOrden />} />

                {/*Licencias*/}
                <Route path="/licencias/" element={<Licencias />} />
                <Route path="/licencias/detalle/:id" element={<DetallesLicencia />} />
                <Route path="/licencias/nueva/:idClienteAkasia?" element={<NuevaLicencia />} />
                <Route path="/licencias/nueva-servidor/:idClienteAkasia?" element={<NuevaLicenciaServidor />} />
                <Route path="/licencias/nueva-caja/:idClienteAkasia?" element={<NuevaLicenciaCaja />} />
                <Route path="/licencias/nueva-nube/:idClienteAkasia?" element={<NuevaLicenciaNube />} />
                <Route path="/licencias/nueva-app-comandas/:idClienteAkasia?" element={<NuevaAppComandas />} />
                <Route path="/licencias/nueva-akasiapos/:idClienteAkasia?" element={<NuevaLicenciaAkasiaPOS />} />
                <Route path="/licencias/informacionIncompleta/:vFiltro" element={<LicenciasInfoIncompleta />} />

                <Route path="/logservicios/logs" element={<LogServicios />} />

                <Route path="/polizas/detalle/:id" element={<DetallesPoliza />} />



                <Route path="/servicios/usuarios-nube-akasia/" element={<UsuariosNubeAkasia />} />
                <Route path="/servicios/usuarios-nube-akasia/nueva" element={<NuevoUsuarioNubeAkasia />} />
                <Route path="/servicios/usuarios-nube-akasia/editar/:id" element={<EditarUsuarioNubeAkasia />} />
                <Route path="/servicios/facturacion-ecuador" element={<FacturaDocumentosEcuador />} />
                <Route path="/servicios/facturacion-guatemala" element={<FacturaDocumentosGuatemala />} />
                <Route path="/servicios/facturacion-panama" element={<PlanesFacturacionPanama />} />
                <Route path="/servicios/facturacion-peru" element={<PlanesFacturacionPeru />} />
                <Route path="/servicios/facturacion-bolivia" element={<PlanesFacturacionBolivia />} />
                <Route path="/servicios/facturacion-elsalvador" element={<PlanesFacturacionElSalvador />} />
                <Route path="/servicios/facturacion-costarica" element={<PlanesFacturacionCostaRica />} />
                <Route path="/servicios/facturacion-republica-dominicana" element={<PlanesFacturacionRepublicaDominicana />} />
                <Route path="/servicios/registro-taecel" element={<RecargasTaecel />} />

                {/* support desk */}

                <Route path="/soporte-tecnico/detalles-soporte/:id" element={<DetallesSoporte />} />


                <Route path="/productos/Catalogo" element={<Productos />} />
                <Route path="/productos/Nuevo" element={<AgregarProductos />} />
                <Route path="/productos/Detalle/:id" element={<DetalleProducto />} />

                {/*Módulos*/}
                <Route path="/modulos/catalogo" element={<CatModulos />} />


                {/* Metas de venta */}
                <Route path="/perfil/:id?" element={<Profile />} />


                {/* Marketing */}

                <Route path="/marketing/caºdario-editorial" element={<CalendarioEditorial />} />
                <Route path="/marketing/dashboard" element={<MarketingDashboard />} />

            </Route>


        </Routes>
    );
};

export default FalconRoutes;
